import EntityContentType from '@/constants/EntityContentType';
import EmailParticipantTypes from '../constants/EmailParticipantTypes';

export default function determineEmailEntityType(sender) {
  if (sender.resourceType === EmailParticipantTypes.CONSTITUENT) {
    return EntityContentType.EMAIL_SENT;
  }

  return EntityContentType.EMAIL_RECEIVED;
}
